import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Calculator from '../views/Calculator.vue'
import Instructions from '../views/Instructions.vue'
import DataEntry from '../views/DataEntry.vue'
import Results from '../views/Results.vue'
import store from '@/store'

Vue.use(VueRouter)

const routes = [
  {
    alias: '',
    path: '/home',
    name: 'Home',
    component: Home
  },
  {
    path: '/instructions',
    name: 'Instructions',
    component: Instructions
  },
  {
    path: '/calculator',
    name: 'Calculator',
    component: Calculator,
    children: [
      {
        alias: '',
        path: '/calculator/data',
        name: 'Data entry',
        component: DataEntry
      },
      {
        path: '/calculator/results',
        name: 'Results',
        component: Results,
        beforeEnter: (to:any, from:any, next:any) => {
          if (store.state.errors.length > 0) {
            next(false)
          } else {
            next()
          }
        }
      }
    ]
  }
]

const router = new VueRouter({
  routes,
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})

export default router
